import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { useSEO } from "@/lib/seo";

const TermsPage = () => {
  const seo = useSEO(
    "Terms of Service",
    "ClearSlot terms governing platform access and API usage.",
    "https://clearslot.io/terms",
  );
  return (
    <div className="min-h-screen bg-background">
      {seo}

      <Navbar />

      <main className="container max-w-3xl mx-auto px-6 py-24 pt-32">
        <p className="text-sm text-muted-foreground mb-2">Last updated: April 2026</p>
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-10">Terms of Service</h1>

        <div className="space-y-10 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">1. Acceptance of terms</h2>
            <p>
              By accessing or using ClearSlot, you agree to be bound by these Terms of Service. If you do not
              agree, you may not use the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">2. Description of service</h2>
            <p>
              ClearSlot provides neutral booking coordination infrastructure for platforms. We do not own the
              customer relationship and act as a data processor for partner platforms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">3. Partner responsibilities</h2>
            <p>
              Partners are responsible for the accuracy of data submitted to ClearSlot, must obtain appropriate
              legal basis for processing guest data, and must not misuse the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">4. Prohibited uses</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Submitting false or fabricated guest signals</li>
              <li>Using the service to send spam or unsolicited communications</li>
              <li>Scraping, reverse engineering, or unauthorised access</li>
              <li>Any use that violates applicable law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">5. Limitation of liability</h2>
            <p>
              ClearSlot is provided on an "as-is" basis. To the maximum extent permitted by law, ClearSlot
              disclaims all warranties and shall not be liable for any indirect, incidental, or consequential
              damages arising from use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">6. Termination</h2>
            <p>
              We may suspend or terminate access to the service at any time for breach of these terms. You may
              terminate your account at any time by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">7. Governing law</h2>
            <p>
              These terms are governed by Danish law. Any disputes shall be subject to the exclusive
              jurisdiction of the courts of Denmark.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">8. Contact</h2>
            <p>
              Questions about these terms? Email{" "}
              <a href="mailto:legal@clearslot.io" className="text-foreground underline hover:text-primary">legal@clearslot.io</a>.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
